import { cva, type VariantProps } from "class-variance-authority";
import * as React from "react";
import { cn } from "@/shared/lib/utils";

/** Chip (címke): 11 px / 600, 6 px rádiusz. highlight = gold-soft + gold-text;
 *  neutral = 1 px line keret + muted; onCard = fehér + ink (kiemelt kártyán belül);
 *  pending = „Jóváhagyásra vár" (gray + muted); subtle = ugyanaz a halk szürke, de
 *  másodlagos meta-információhoz (pl. fejezet-jelölés a fogalomtárban). */
const chipVariants = cva(
  "inline-flex items-center rounded-chip px-2 py-1 text-[11px] font-semibold leading-none",
  {
    variants: {
      variant: {
        highlight: "bg-gold-soft text-gold-text",
        neutral: "border border-line text-muted",
        onCard: "bg-white text-ink",
        pending: "bg-gray text-muted",
        subtle: "bg-gray text-muted",
        danger: "bg-gray text-red",
      },
    },
    defaultVariants: { variant: "highlight" },
  },
);

export function Chip({
  className,
  variant,
  ...props
}: React.HTMLAttributes<HTMLSpanElement> & VariantProps<typeof chipVariants>) {
  return <span className={cn(chipVariants({ variant }), className)} {...props} />;
}
